import React, { PureComponent, Fragment } from 'react'
import QRCode from 'qrcode'

class QR extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            content: <div>Loading...</div>,
        }
    }

    setContent = () => {
        const { campaignLink, uuid } = this.props
        QRCode.toDataURL(campaignLink, { width: 1080 })
            .then((dataUrl) => {
                this.setState({
                    content: (
                        <Fragment>
                            <img style={{ display: 'block' }} id={`qr_${uuid}`} src={dataUrl} width="100" alt="" />
                        </Fragment>
                    ),
                })
            })
    }

    componentDidMount() {
        this.setContent()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.uuid !== this.props.uuid) {
            this.setContent()
        }
    }

    render() {
        const { content } = this.state
        return (
            <Fragment>
                {content}
            </Fragment>
        )
    }
}

export default QR
